// 9fbef606107a605d69c0edbcd8029e5d
import ADD_PICKUP_CONSTANTS from './AddPickUpPersonForm.constants';

const initialState = {
  pickUpErrorMessage: null,
  showSuccessMsg: false,
  showErrorMsg: false,
  loader: false,
  formState: false,
  modalData: null,
  resetOrderPaginationState: false,
};

const AddPickUpPersonReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PICKUP_CONSTANTS.SET_PICKUP_PERSON_ERROR_MSG:
      return { ...state, ...{ pickUpErrorMessage: action.payload } };
    case ADD_PICKUP_CONSTANTS.SHOW_SUCCESS_MSG:
      return { ...state, ...{ showSuccessMsg: action.payload } };
    case ADD_PICKUP_CONSTANTS.SHOW_ERROR_MSG:
      return { ...state, ...{ showErrorMsg: action.payload } };
    case ADD_PICKUP_CONSTANTS.SHOW_LOADER:
      return { ...state, ...{ loader: true } };
    case ADD_PICKUP_CONSTANTS.HIDE_LOADER:
      return { ...state, ...{ loader: false } };
    case ADD_PICKUP_CONSTANTS.OPEN_FORM:
      return { ...state, ...{ formState: action.payload } };
    case ADD_PICKUP_CONSTANTS.SET_MODAL_DATA:
      return { ...state, ...{ modalData: action.payload } };
    case ADD_PICKUP_CONSTANTS.RESET_ORDER_PAGINATION:
      return { ...state, ...{ resetOrderPaginationState: action.payload } };
    case ADD_PICKUP_CONSTANTS.RESET_STATE:
      return { ...state, ...{ showErrorMsg: false, pickUpErrorMessage: null } };
    default:
      return state;
  }
};

export default AddPickUpPersonReducer;
